export const ESHOP_COMPARISON_TEST_ID = {
    COMPARISON_REMOVE_PRODUCT: 'comparison-remove-product',
    COMPARISON_SELECT_PRODUCT: 'comparison-select-product',
};
